<template>
  <div class="directory-grid">
    <DirectoryGridItem
      :key="item.id"
      :item="item"
      :assets="assets"
      v-for="item in items"
    />
  </div>
</template>

<script>
import DirectoryGridItem from './DirectoryGridItem'

export default {
  name: 'DirectoryGrid',

  components: {
    DirectoryGridItem
  },

  props: {
    type: {
      type: String
    },
    items: {
      type: Array,
      default: () => []
    },
    assets: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
